// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  name: 'aera-augsburg-prod',
  version: 'Error: no tags found (local or remote).',
  production: false,
  bucketName: 'aera-augsburg',
  databaseUrl: { supabase: 'https://jvexnsciyxgvzbznhmmy.supabase.co', middleware: '' },
  posCloud: {
    apiURL: 'https://aera-augsburg.menucat.de/api',
  },
  editEnabled: 'true',
  defaultLanguage: 'DE',
  databaseAnonKey: { supabase: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imp2ZXhuc2NpeXhndnpiem5obW15Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODgwODk3NzUsImV4cCI6MjEwMzY2NTc3NX0.fNR44JwB771zxoMFH1PxuFZijvqjqBYxVeiIHXf3vU8', middleware: '' },
  sentryDSN: '',
  posthogKey: 'phc_m3dOImc0jDJ5IzfKERikqSr4Nshq8XFVWV6DJKgYzhu',
  posthogHost: 'https://eu.i.posthog.com',
  posthogProxyHost: 'https://t.unauorder.com',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
